const indexSearch = () => import('@/pages/indexSearch')
const searchBaseInfo = () => import('@/pages/indexSearch/baseInfo/index')
const searchBaseCertificate = () => import('@/pages/indexSearch/searchBaseCertificate/index')
const searchBaseCarSign = () => import('@/pages/indexSearch/searchBaseCarSign/index')
const searchBaseRepair = () => import('@/pages/indexSearch/searchBaseRepair/index')
const searchBaseTicket = () => import('@/pages/indexSearch/searchBaseTicket/index')
const searchBaseTravel = () => import('@/pages/indexSearch/searchBaseTravel/index')
const searchMonitorInformation = () => import('@/pages/indexSearch/searchMonitorInformation/index')
const lockRecord = () => import('@/pages/indexSearch/lockRecord/index')
const searchBaseMaintenance = () => import('@/pages/indexSearch/searchBaseMaintenance/index')
const insurance = () => import('@/pages/indexSearch/insurance')
const insuranceHistory = () => import('@/pages/indexSearch/insuranceHistory/index')
const insuranceHistoryDetail = () => import('@/pages/indexSearch/insuranceHistory/insuranceHistoryDetail')
const commodityInformation = () => import('@/pages/indexSearch/commodityInformation/index')
const claimReceipt = () => import('@/pages/indexSearch/insuranceHistory/claimReceipt')
const insurance1 = () => import('@/pages/indexSearch/insuranceDetail/insurance1')
const insurance2 = () => import('@/pages/indexSearch/insuranceDetail/insurance2')
const rentHistory = () => import('@/pages/indexSearch/rentHistory')
const indexSearchList = () => import('@/pages/indexSearch/indexSearchList')
const indexMapDetail = () => import('@/pages/indexSearch/indexMapDetail')
const infoSetting = () => import('@/pages/indexSearch/infoSetting')
const carHistoryRemark = () => import('@/pages/indexSearch/carHistoryRemark')
const carRemark = () => import('@/pages/indexSearch/carRemark')
const health = () => import('@/pages/indexSearch/health')
const qualityControlRecord = () => import('@/pages/indexSearch/qualityControlRecord')
const refitRecord = () => import('@/pages/indexSearch/refitRecord')
export default [
  {
    path: '/indexSearch',
    name: 'indexSearch',
    component: indexSearch,
    // redirect: '/stationOperation/findCarQuickly',
    meta: {}
  },
  {
    path: '/searchBaseInfo',
    name: 'searchBaseInfo',
    component: searchBaseInfo,
    meta: {}
  },
  {
    path: '/searchBaseCertificate',
    name: 'searchBaseCertificate',
    component: searchBaseCertificate,
    meta: {}
  },
  {
    path: '/searchBaseCarSign',
    name: 'searchBaseCarSign',
    component: searchBaseCarSign,
    meta: {}
  },
  {
    path: '/searchBaseRepair',
    name: 'SearchBaseRepair',
    component: searchBaseRepair,
    meta: {
      cache: true
    }
  },
  {
    path: '/searchBaseTicket',
    name: 'searchBaseTicket',
    component: searchBaseTicket,
    meta: {}
  },
  {
    path: '/searchBaseTravel',
    name: 'searchBaseTravel',
    component: searchBaseTravel,
    meta: {}
  },
  {
    path: '/searchMonitorInformation',
    name: 'searchMonitorInformation',
    component: searchMonitorInformation,
    meta: {}
  },
  {
    path: '/lockRecord',
    name: 'LockRecord',
    component: lockRecord,
    meta: {}
  },
  {
    path: '/new-workorder',
    name: 'NewWorkorder',
    component: () => import('@/pages/indexSearch/newWorkOrder/index.vue'),
    meta: {}
  },
  {
    path: '/searchBaseMaintenance',
    name: 'searchBaseMaintenance',
    component: searchBaseMaintenance,
    meta: {}
  },
  {
    path: '/insurance1',
    name: 'insurance1',
    component: insurance1,
    meta: {}
  },
  {
    path: '/insuranceHistory',
    name: 'insuranceHistory',
    component: insuranceHistory,
    meta: {}
  },
  {
    path: '/insuranceHistoryDetail',
    name: 'insuranceHistoryDetail',
    component: insuranceHistoryDetail,
    meta: {}
  },
  {
    path: '/insurance2',
    name: 'insurance2',
    component: insurance2,
    meta: {}
  },

  {
    path: '/insurance',
    name: 'insurance',
    component: insurance,
    meta: {}
  },

  {
    path: '/commodityInformation',
    name: 'commodityInformation',
    component: commodityInformation,
    meta: {}
  },
  {
    path: '/claimReceipt',
    name: 'claimReceipt',
    component: claimReceipt,
    meta: {}
  },

  {
    path: '/rentHistory',
    name: 'rentHistory',
    component: rentHistory,
    meta: {}
  },
  {
    path: '/indexSearchList',
    name: 'indexSearchList',
    component: indexSearchList,
    meta: {
      storeKey: 'trs.vehicleFile.index'
    }
  },
  {
    path: '/indexMapDetail',
    name: 'indexMapDetail',
    component: indexMapDetail,
    meta: {}
  },
  {
    path: '/infoSetting',
    name: 'infoSetting',
    component: infoSetting,
    meta: {}
  },
  {
    path: '/carHistoryRemark',
    name: 'carHistoryRemark',
    component: carHistoryRemark,
    meta: {}
  },
  {
    path: '/carRemark',
    name: 'carRemark',
    component: carRemark,
    meta: {}
  },
  {
    path: '/health',
    name: 'health',
    component: health,
    meta: {}
  },
  // 质检记录
  {
    path: '/qualityControlRecord',
    name: 'qualityControlRecord',
    component: qualityControlRecord,
    meta: {}
  },
  // 技改记录
  {
    path: '/refitRecord',
    name: 'refitRecord',
    component: refitRecord,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/indexSearch/index.js